import { EventEmitter, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GeneralService } from './general.service';
import { MigrationUtilityService } from './migration-utility.service';
import { InputFuntionService } from './input-funtion.service';
import { InputsGeneralForm } from '../models/pages-model/form-general.model';
import { Observable, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ButtonFunctionService {
  public emitFuntion = new EventEmitter<boolean>();

  constructor(
    public dialog: MatDialog,
    private generalService: GeneralService,
    private migrationUtilityService: MigrationUtilityService,
    private inputFuntionService: InputFuntionService,
  ) {}

  public inputFunction(
    dataInput: string,
    quotationId: string | number,
    field?: InputsGeneralForm,
    multiformCount = 1,
  ): string | null {
    if (dataInput == 'changeStaus13') {
      this.emitFuntion.pipe(take(1)).subscribe(() => {
        this.changeStaus13(quotationId ?? 0);
      });
      return 'saveAndValidFull';
    }
    if (dataInput == 'saveAndValidFull') {
      return this.saveFullPage();
    }
    // Palabras clave explícitas: cada botón debe declarar cuál de los dos servicios ejecutar
    if (dataInput == 'deleteAval' || dataInput == 'deleteApoderado') {
      this.deleteMultiform(dataInput, quotationId, field, multiformCount);
      return null;
    }
    return null;
  }

  // Indica si la función del botón borra un multiformulario (también usado para darle un estilo distinto al botón)
  public isDeleteFunction(dataInput?: string | null): boolean {
    return !!dataInput && dataInput.toLowerCase().includes('delete');
  }

  // Elimina un multiformulario (aval/apoderado) siempre que quede al menos uno
  private deleteMultiform(
    dataInput: string,
    quotationId: string | number,
    field: InputsGeneralForm | undefined,
    multiformCount: number,
  ): void {
    if (!field) return;
    if (multiformCount <= 1) {
      this.generalService.viewSnacAlert(
        'No se puede eliminar',
        'alert',
        'Debe existir al menos un formulario',
      );
      return;
    }
    const parts = field.idFullControl.split('-');
    const idForm = Number(parts[1]);
    const repeatIndex = Number(parts[2]);

    let deleteObservable: Observable<any | null>;
    switch (dataInput) {
      case 'deleteAval':
        deleteObservable = this.migrationUtilityService.deleteGuarantor(
          Number(quotationId),
          repeatIndex,
        );
        break;
      case 'deleteApoderado':
        deleteObservable = this.migrationUtilityService.deleteAttorney(
          Number(quotationId),
          repeatIndex,
        );
        break;
      default:
        return;
    }

    deleteObservable.subscribe((ress) => {
      if (ress !== null) {
        this.generalService.viewSnacAlert('Eliminado', 'normal', 'Formulario eliminado');
        this.inputFuntionService.emitFuntionInput.emit({
          action: 'deleteMultiform',
          body: { idForm, repeatIndex },
        });
      }
    });
  }

  public changeStaus13(ticketId: string | number): void {
    const userId = localStorage.getItem('userId');
    this.migrationUtilityService
      .changeQuotationStatus({
        quotationId: Number(ticketId),
        userId: Number(userId),
        newStatus: 'PARA_ANALISIS',
        comment: 'Cambio de Faceautomatico',
      })
      .subscribe(() => {
        this.generalService.viewSnacAlert('Cambio de Face', 'normal', 'Guardado');
        this.generalService.goToUrl(['/workflow'], {
          statusSelected: 1,
        });
      });
  }

  // Emite un evento para guardar toda la página completa
  public saveFullPage(): string {
    return 'saveAndValidFull';
  }
}
